import styled from 'styled-components/native';

export const FlexView = styled.View`
  flex: 1;
`;

export const ContentContainer = styled.View`
  bottom: ${({ $bottom }) => $bottom || 0}px;
`;
